import * as React from "react";
import { DataGrid, ruRU } from "@mui/x-data-grid";
import { useDispatch } from "react-redux";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { useAppSelector } from "../../hooks";

import { contactsDataPage } from "src/features/contacts/contactsActions";

import {
  contactsData,
  contactsDataUpdate,
  contactsDataDelete,
} from "../../features/contacts/contactsActions";

import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import { useEffect } from "react";

import Typography from "@mui/material/Typography";

export default function ContactsPaginationGrid({
  clients1_id,
  childToParent,
  selectedRow,
}) {
  const dispatch = useDispatch();

  const { dataClientsPage } = useAppSelector((state) => state.clientsPage);

  const { dataContactsPage } = useAppSelector((state) => state.contactsPage);

  const [selectedRows, setSelectedRows] = React.useState([]);

  const [snackbar, setSnackbar] = React.useState(null);

  const [paginationModel, setPaginationModel] = React.useState({
    page: 0,
    pageSize: 10,
  });

  const { pageInfo, setPageInfo } = {
    totalRowCount: dataClientsPage?.payload?.count,
  };

  // Some API clients return undefined while loading
  // Following lines are here to prevent `rowCountState` from being undefined during the loading
  const [rowCountState, setRowCountState] = React.useState(
    pageInfo?.totalRowCount || 0
  );
  React.useEffect(() => {
    setRowCountState((prevRowCountState) =>
      pageInfo?.totalRowCount !== undefined
        ? pageInfo?.totalRowCount
        : prevRowCountState
    );
  }, [pageInfo?.totalRowCount, setRowCountState]);

  useEffect(() => {
    dispatch(
      contactsDataPage([
        paginationModel.page,
        paginationModel.pageSize,
        clients1_id,
      ])
    ).then(() => {
      setRowCountState({ totalRowCount: dataClientsPage?.payload?.count });
    });
  }, [
    clients1_id,
    dataClientsPage?.payload?.count,
    dispatch,
    paginationModel.page,
    paginationModel.pageSize,
  ]);

  const columns = [
    { field: "id", headerName: "ID", width: 40 },
    { field: "name", headerName: "Контакт", width: 400, editable: true },
    {
      field: "client",
      headerName: "Клиент",
      width: 200,
      editable: false,
      renderCell: (params) => (
        <div>
          <div
            key={
              "client_contacts " +
              params.row.id +
              " " +
              " " +
              params.row.client?.id
            }
          >
            <Typography variant="h10" color="textSecondary">
              {params.row.client?.title}
            </Typography>
          </div>
        </div>
      ),
    },
    {
      field: "phones",
      headerName: "Телефоны",
      width: 200,
      editable: true,
      renderCell: (params) => (
        <div>
          {params.row.phones.map((phone, j) => (
            <div
              key={"client_contacts " + params.row.id + " " + phone + " " + j}
            >
              <Typography variant="h10" color="textSecondary">
                {phone}
              </Typography>
            </div>
          ))}
        </div>
      ),
    },
    {
      field: "emails",
      headerName: "Почта",
      width: 200,
      editable: true,
      renderCell: (params) => (
        <div>
          {params.row.emails.map((email, j) => (
            <div
              key={"client_contacts " + params.row.id + " " + email + " " + j}
            >
              <Typography variant="h10" color="textSecondary">
                {email}
              </Typography>
            </div>
          ))}
        </div>
      ),
    },

    { field: "position", headerName: "Должность", width: 200, editable: true },

    { field: "comment", headerName: "Комментарий", width: 200, editable: true },

    {
      field: "action",
      headerName: "",
      width: 120,
      sortable: false,
      disableClickEventBubbling: true,

      renderCell: (params) => {
        const onClickRemove = (e) => {
          if (clients1_id?.id) {
            dispatch(contactsDataDelete(params.row)).then(() => {
              dispatch(contactsData(clients1_id));
              childToParent(true);
              setSnackbar({
                children: "Данные удалены !",
                severity: "success",
              });
            });
          } else {
            dispatch(contactsDataDelete(params.row)).then(() => {
              dispatch(contactsData(clients1_id));
              childToParent(true);
              setSnackbar({
                children: "Данные удалены !",
                severity: "success",
              });
            });
          }
        };

        return (
          <Stack direction="row" spacing={0}>
            <Button
              variant="outlined"
              color="error"
              size="small"
              onClick={onClickRemove}
              sx={{
                width: 100,
              }}
            >
              Удалить
            </Button>
          </Stack>
        );
      },
    },
  ];

  const [sortModel, setSortModel] = React.useState([
    {
      field: "id",
      sort: "asc",
    },
  ]);

  const handleProcessRowUpdateError = React.useCallback((error) => {
    setSnackbar({ children: error.message, severity: "error" });
  }, []);

  const processRowUpdate = React.useCallback(
    async (newRow) => {
      if (
        typeof newRow === "object" &&
        newRow !== null &&
        !Array.isArray(newRow.emails)
      ) {
        let array = newRow.emails.split(",").map(String);
        newRow.emails = array;
      }

      if (
        typeof newRow === "object" &&
        newRow !== null &&
        !Array.isArray(newRow.phones)
      ) {
        let array = newRow.phones.split(",").map(String);
        newRow.phones = array;
      }

      const response = await dispatch(contactsDataUpdate(newRow));
      setSnackbar({ children: "Данные обновлены !", severity: "success" });
      return response.payload; // return the new row containing the row id
    },
    [dispatch]
  );

  const handleCloseSnackbar = () => setSnackbar(null);

  const handleRowSelection = (e) => {
    setSelectedRows(e);
  };

  React.useEffect(() => {
    selectedRow(selectedRows);
  }, [selectedRow, selectedRows]);

  return (
    <div style={{ height: 400, width: "100%" }}>
      <DataGrid
        localeText={ruRU.components.MuiDataGrid.defaultProps.localeText}
        getRowHeight={() => "auto"}
        rows={dataContactsPage?.payload?.list ?? []}
        rowCount={dataContactsPage?.payload?.count ?? 0}
        loading={dataContactsPage?.loading}
        columns={columns}
        pageSizeOptions={[5, 10]}
        paginationModel={paginationModel}
        paginationMode="server"
        onPaginationModelChange={setPaginationModel}
        processRowUpdate={processRowUpdate}
        onProcessRowUpdateError={handleProcessRowUpdateError}
        sortModel={sortModel}
        onSortModelChange={(model) => setSortModel(model)}
        onRowSelectionModelChange={handleRowSelection}
      />

      {!!snackbar && (
        <Snackbar
          open
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          onClose={handleCloseSnackbar}
          autoHideDuration={1500}
        >
          <Alert {...snackbar} onClose={handleCloseSnackbar} />
        </Snackbar>
      )}
    </div>
  );
}
